import {call, put, select, takeLatest} from 'redux-saga/effects'

import * as receiptActions from '../actions/receipt'
import * as userSelectors from '../store/user'

import {getEventTransactions} from '../api/eventAndLooks'
import {isBadResponse} from '../api/statusCodes'

export function* fetchTransactionsWorker({payload: {eventId}}) {
  const userId = yield select(userSelectors.id)
  yield put(receiptActions.fetchTransactionsPending())
  try {
    const {json, status} = yield call(getEventTransactions, {eventId, userId})
    if (isBadResponse(status)) {
      throw new Error('Unable to fetch event transactions')
    }
    yield put(receiptActions.fetchTransactionsSuccess({...json}))
  } catch (err) {
    yield put(receiptActions.fetchTransactionsFailure(err))
  }
}

export function* fetchTransactionsSaga() {
  yield takeLatest(receiptActions.FETCH_TRANSACTIONS, fetchTransactionsWorker)
}
